(function () {
  'use strict';

  function initHeader(root) {
    if (!root || root.dataset.mhReady === 'true') return;
    root.dataset.mhReady = 'true';

    var header = root.querySelector('.mh-header');
    var menuItems = root.querySelectorAll('[data-mh-menu-item]');
    var search = root.querySelector('[data-mh-search]');
    var searchOpen = root.querySelector('[data-mh-search-open]');
    var searchClose = root.querySelector('[data-mh-search-close]');
    var searchInput = root.querySelector('[data-mh-search-input]');
    var searchResults = root.querySelector('[data-mh-search-results]');
    var mobile = root.querySelector('[data-mh-mobile]');
    var mobileOpen = root.querySelector('[data-mh-mobile-open]');
    var mobileCloses = root.querySelectorAll('[data-mh-mobile-close]');
    var mobileTargets = root.querySelectorAll('[data-mh-mobile-target]');
    var mobileBacks = root.querySelectorAll('[data-mh-mobile-back]');
    var searchTimer;

    function updateHeaderPosition() {
      if (!header) return;
      root.style.setProperty('--mh-actual-bottom', header.getBoundingClientRect().bottom + 'px');
    }

    function closeMenus(except) {
      menuItems.forEach(function (item) {
        if (item !== except) item.classList.remove('is-open');
      });
    }

    menuItems.forEach(function (item) {
      var link = item.querySelector(':scope > .mh-menu__link');
      var panel = item.querySelector(':scope > [data-mh-panel]');
      if (!link || !panel) return;
      link.addEventListener('click', function (event) {
        if (window.matchMedia('(hover: none)').matches && !item.classList.contains('is-open')) {
          event.preventDefault();
          closeMenus(item);
          item.classList.add('is-open');
        }
      });
    });

    function openSearch() {
      if (!search) return;
      closeMenus();
      search.hidden = false;
      searchOpen.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('mh-no-scroll');
      window.setTimeout(function () { if (searchInput) searchInput.focus(); }, 20);
    }

    function closeSearch() {
      if (!search) return;
      search.hidden = true;
      if (searchOpen) searchOpen.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('mh-no-scroll');
    }

    function openMobile() {
      if (!mobile) return;
      showMobilePanel('main');
      mobile.hidden = false;
      mobileOpen.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('mh-no-scroll');
    }

    function closeMobile() {
      if (!mobile) return;
      mobile.hidden = true;
      if (mobileOpen) mobileOpen.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('mh-no-scroll');
    }

    function showMobilePanel(name) {
      if (!mobile) return;
      mobile.querySelectorAll('[data-mh-mobile-panel]').forEach(function (panel) {
        panel.classList.remove('is-active', 'is-behind');
        if (panel.dataset.mhMobilePanel === name) panel.classList.add('is-active');
        else if (name !== 'main' && panel.dataset.mhMobilePanel === 'main') panel.classList.add('is-behind');
      });
    }

    if (searchOpen) searchOpen.addEventListener('click', openSearch);
    if (searchClose) searchClose.addEventListener('click', closeSearch);
    if (mobileOpen) mobileOpen.addEventListener('click', openMobile);
    mobileCloses.forEach(function (button) { button.addEventListener('click', closeMobile); });
    mobileTargets.forEach(function (button) { button.addEventListener('click', function () { showMobilePanel(button.dataset.mhMobileTarget); }); });
    mobileBacks.forEach(function (button) { button.addEventListener('click', function () { showMobilePanel('main'); }); });

    document.addEventListener('click', function (event) {
      if (!root.contains(event.target)) closeMenus();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') { closeMenus(); closeSearch(); closeMobile(); }
    });

    if (searchInput && searchResults) {
      searchInput.addEventListener('input', function () {
        window.clearTimeout(searchTimer);
        var query = searchInput.value.trim();
        if (query.length < 2) { searchResults.innerHTML = ''; return; }
        searchTimer = window.setTimeout(function () {
          fetch(window.Shopify.routes.root + 'search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=4')
            .then(function (response) { return response.ok ? response.json() : Promise.reject(response); })
            .then(function (data) {
              var products = (((data || {}).resources || {}).results || {}).products || [];
              searchResults.innerHTML = '';
              products.forEach(function (product) {
                var card = document.createElement('a');
                card.className = 'mh-search-card';
                card.href = product.url;
                if (product.image) {
                  var img = document.createElement('img');
                  img.src = product.image;
                  img.alt = product.title;
                  img.loading = 'lazy';
                  card.appendChild(img);
                }
                var title = document.createElement('span');
                title.textContent = product.title;
                card.appendChild(title);
                searchResults.appendChild(card);
              });
            })
            .catch(function () { searchResults.innerHTML = ''; });
        }, 250);
      });
    }

    function updateCartCount() {
      fetch(window.Shopify.routes.root + 'cart.js')
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          var count = root.querySelector('[data-mh-cart-count]');
          var cartLink = root.querySelector('[data-mh-cart]');
          if (!count) return;
          count.textContent = cart.item_count;
          count.hidden = cart.item_count === 0;
          if (cartLink) cartLink.setAttribute('aria-label', 'Cart, ' + cart.item_count + ' items');
        });
    }

    document.addEventListener('cart:updated', updateCartCount);
    document.addEventListener('cart:refresh', updateCartCount);
    document.addEventListener('product:added', updateCartCount);
    window.addEventListener('resize', updateHeaderPosition, { passive: true });
    window.addEventListener('scroll', updateHeaderPosition, { passive: true });
    updateHeaderPosition();
  }

  function initAll() {
    document.querySelectorAll('[data-mh-header]').forEach(initHeader);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();

document.addEventListener('DOMContentLoaded', function () {
  const stickyHeader = document.querySelector('.mh-shell.mh-shell--sticky');

  if (!stickyHeader) return;

  function toggleScrolledClass() {
    stickyHeader.classList.toggle('mh-is-scrolled', window.scrollY >= 50);
  }

  toggleScrolledClass();

  window.addEventListener('scroll', toggleScrolledClass, {
    passive: true
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const stickyHeader = document.querySelector('.mh-shell.mh-shell--sticky');

  if (!stickyHeader) return;

  let headerPlaceholder = null;

  function toggleStickyHeader() {
    const isScrolled = window.scrollY >= 50;

    if (isScrolled) {
      if (!headerPlaceholder) {
        headerPlaceholder = document.createElement('div');
        headerPlaceholder.className = 'mh-sticky-placeholder';
        headerPlaceholder.style.height = `${stickyHeader.offsetHeight}px`;

        stickyHeader.parentNode.insertBefore(
          headerPlaceholder,
          stickyHeader.nextSibling
        );
      }

      stickyHeader.classList.add('mh-is-scrolled');
    } else {
      stickyHeader.classList.remove('mh-is-scrolled');

      if (headerPlaceholder) {
        headerPlaceholder.remove();
        headerPlaceholder = null;
      }
    }
  }

  toggleStickyHeader();

  window.addEventListener('scroll', toggleStickyHeader, {
    passive: true
  });

  window.addEventListener('resize', function () {
    if (headerPlaceholder) {
      headerPlaceholder.style.height = `${stickyHeader.offsetHeight}px`;
    }
  });
});